const my_profile = {
  viewMyClubSeacretProfile: "Δείτε το προφίλ μου ClubSeacret", // translated
  viewMoreDetails: "Δείτε περισσότερες λεπτομέρειες", // translated
  verifiedEmail: "Επαληθευμένο email", // translated
  unverifiedEmail: "Μη επαληθευμένο email", // translated
  createdFrom: "Δημιουργήθηκε από", // translated
  createdTo: "Δημιουργήθηκε έως", // translated
  selectStatus: "Επιλέξτε κατάσταση...", // translated
  searchByTitle: "Αναζήτηση με τίτλο...", // translated
  pushNotifications: "Push Ειδοποιήσεις", // translated 
  pushNotificationsDescription: "Λάβετε ειδοποιήσεις του προγράμματος περιήγησης για ενημερώσεις και συμβάντα", // translated 
  pushNotificationsNotSupported: "Οι push ειδοποιήσεις δεν υποστηρίζονται σε αυτό το πρόγραμμα περιήγησης", // translated 
  pushNotificationsDeniedMessage: "Η άδεια ειδοποίησης απορρίφθηκε. Παρακαλώ ενεργοποιήστε τις ειδοποιήσεις στις ρυθμίσεις του προγράμματος περιήγησης για να λάβετε push ειδοποιήσεις.", // translated 
  pushNotificationsEnabled: "Οι push ειδοποιήσεις ενεργοποιήθηκαν με επιτυχία", // translated 
  pushNotificationsDisabled: "Οι push ειδοποιήσεις απενεργοποιήθηκαν με επιτυχία", // translated 
  userInformationMissing: "Λείπουν πληροφορίες χρήστη", // translated 
  failedToUpdatePushNotifications: "Αποτυχία ενημέρωσης των ρυθμίσεων push ειδοποιήσεων", // translated 
  notificationPermissionDenied: "Η άδεια ειδοποίησης απορρίφθηκε. Παρακαλώ ενεργοποιήστε τις ρυθμίσεις του προγράμματος περιήγησης.", // translated 
  notificationPermissionRequired: "Απαιτείται άδεια ειδοποίησης για να γίνει η push ειδοποιήσεις", // translated 
  notSupported: "Δεν υποστηρίζεται", // translated 
  permissionDenied: "Άδεια απορρίφθηκε", // translated 
  permissionNotRequested: "Άδεια δεν ζητήθηκε", // translated 
  enabled: "Ενεργοποιημένο", // translated 
  disabled: "Απενεργοποιημένο", // translated 
};


export default my_profile;
